import React, { useState, useEffect, useContext } from 'react';
import FieldDropdown from '../../../../components/FieldDropdown/FieldDropdown';
import { API } from '../../../../API/API';
import { UserContext } from '../../../../context/UserContext';
import FieldDate from '../../../../components/FieldDate/FieldDate';
import FieldText from '../../../../components/FieldText/FieldText';
import { message } from 'antd';
import { MessageConst } from '../../../../const/MessageConst';
import { Row, Col } from 'antd';
import FieldDropdownMulti from '../../../../components/FieldDropdownMulti/FieldDropdownMulti';
import FieldUpload from '../../../../components/FieldUpload/FieldUpload';
import { constData } from '../../../../const/Const';
import FieldTextArea from '../../../../components/FieldTextArea/FieldTextArea';
import GridBasis from '../../../../components/GridBasis/GridBasis';
import PanelBase from '../../../../components/PanelBase/PanelBase';
import ButtonDefaultWithLoad from '../../../../components/ButtonDefaultWithLoad/ButtonDefaultWithLoad';
import FieldItemList from '../../../../components/FieldItemList/FieldItemList';

const EmpEmplHistNewTR = (props) => {

    const { userInfo } = useContext(UserContext);
    const [initialData] = useState({
        "employmenttype": "TR",
        "historyid": -1,
        "depid": null,
        "positionid": null,
        "begindate": null,
        "enddate": null,
        "basewagecurrcode": "MNT",
        "basewage": 0,
        "insuretypeid": null,
        "labourcondition": "N",
        "ismult": null,
        "multyear": 0,
        "histreason": null,
        "note": null,
        "empid": props.empid,
        "companyid": userInfo.companyid ? userInfo.companyid.toString().toUpperCase() : "",
        "isgovcompany": false,
        "companyname": userInfo.companyname ? userInfo.companyname : "",
        "emptype": props.emptype
    });

    const [data, setData] = useState({ ...initialData });
    const [dHistReasonNames, setDHistReasonNames] = useState([]);
    const [checkRule, setCheckRule] = useState(false);
    const [colSpan] = useState(window.innerWidth > 800 ? 12 : 24);
    const [dTerminateType] = useState(constData.Gov_Terminate_Type);
    const [loading, setLoading] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);

    const getData = async () => {
        let tDHistReasonNames = [];

        setLoading(true);

        await API.get('/api/humanresource/organization/get_hrreason_dropdown?type=TR').then(response => {
            if (response.status === 200 && response.data?.rettype === 0) {
                if (response.data?.retdata?.length > 0) {
                    tDHistReasonNames = response.data.retdata;
                }
            }
        });

        setLoading(false);

        setDHistReasonNames(tDHistReasonNames);
    }

    useEffect(() => {
        getData();
    }, []);


    const getExistsData = async () => {
        let tData = { ...initialData };
        setLoading(true);
        if (props.historyid > 0) {
            await API.get('/api/humanresource/employment/get_empemplhist?historyid=' + props.historyid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data.retdata?.length > 0) {
                        tData = response.data.retdata[0];
                    }
                }
            });
        } else {
            if (props.terminatetype) {
                tData.terminatetype = props.terminatetype;
            }

            await API.get('/api/humanresource/Employment/get_empemplhist_for_date?companyid=' + userInfo.companyid + '&empid=' + props.empid).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    if (response.data.retdata?.length > 0) {
                        tData = { ...tData, ...response.data.retdata[0] };
                    }
                }
            });
        }
        setLoading(false);
        setData(tData);
    }

    useEffect(() => {
        getExistsData();
    }, [props.historyid]);

    const fieldOnChanged = async (key, text, field, fieldname) => {
        if (field) {
            let tData = { ...data };
            tData[field] = key;
            if (fieldname) {
                tData[fieldname] = text;
            }

            if (field == 'enddate' && key) {
                await API.get('/api/humanresource/Employment/get_empemplhist_for_date?companyid=' + userInfo.companyid + '&empid=' + props.empid + '&begindate=' + key).then(response => {
                    if (response.status == 200 && response.data.rettype == 0) {
                        if (response.data.retdata?.length > 0) {
                            tData = { ...tData, ...response.data.retdata[0] };
                        }
                    }
                });
            }
            setData(tData);
        }
    }

    const onSave = async () => {
        setCheckRule(true);

        let vRule = true;

        if (!data.enddate ||
            !data.terminatetype) {
            vRule = false;
        }

        let tData = { ...data };

        if (vRule) {
            setLoadingSave(true);

            tData.empid = props.empid;
            tData.emptype = props.emptype;
            await API.post('/api/humanresource/employment/save_empemplhist', [tData]).then(response => {
                if (response.status == 200 && response.data.rettype == 0) {
                    message.success(MessageConst.success);
                    props.afterSave();
                    onDismiss();
                }
            });
            setLoadingSave(false);
        }
    }

    const onDismiss = () => {
        setData({ ...initialData });
        setCheckRule(false);
        props.onDismiss();
    }

    const onDelete = async () => {
        await API.post('/api/humanresource/employment/delete_empemplhist?historyid=' + props.historyid).then(response => {
            if (response.status == 200 && response.data.rettype == 0) {
                message.success(MessageConst.success);
                props.afterSave();
                onDismiss();
            }
        });
    }

    return (
        <PanelBase
            headerText={props.historyid > 0 ? 'Ажлаас чөлөөлсөн түүх засах' : 'Ажлаас чөлөөлсөн түүх нэмэх'}
            isOpen={props.onOpen}
            onDismiss={onDismiss}
            PanelType='large'
            delete={!props.disable}
            onDelete={onDelete}
            buttons={(
                <div>
                    <ButtonDefaultWithLoad disable={props.disable} loading={loadingSave} onClick={onSave} text="Хадгалах" />
                </div>
            )}
        >
            <div style={{ marginTop: 25 }}>
                <div>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldDropdown loading={loading} required onChanged={fieldOnChanged} title="Ажлаас чөлөөлөх төрөл" data={dTerminateType} keyfield='terminatetype' defaultValue={data.terminatetype} checkreq={checkRule} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldDropdownMulti loading={loading} onChanged={fieldOnChanged} title="Шалтгаан" data={dHistReasonNames} keyfield='histreason' defaultValue={data.histreason} />
                        </Col>
                        <Col span={colSpan}>
                            <FieldDate loading={loading} required onChanged={fieldOnChanged} title="Ажлаас чөлөөлсөн огноо" keyfield='enddate' defaultValue={data.enddate} checkreq={checkRule} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldItemList loading={loading} onChanged={fieldOnChanged} title="Даатгуулагчийн төрөл" keyfield='insuretypeid' keyfieldname='insuretypename' defaultValue={[{ key: data.insuretypeid, name: data.insuretypename }]} dataurl="/api/humanresource/organization/get_insure_type_dropdown" />
                        </Col>
                        <Col span={colSpan}>
                            <FieldItemList disable={true} loading={loading} onChanged={fieldOnChanged} title="Дотоод нэгж" keyfield='depid' keyfieldname='depname' defaultValue={[{ key: data.depid, name: data.depname }]} dataurl="" />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={colSpan}>
                            <FieldItemList disable={true} loading={loading} onChanged={fieldOnChanged} title="Ажлын байр" keyfield='positionid' keyfieldname='positionname' defaultValue={[{ key: data.positionid, name: data.positionname }]} dataurl="" />
                        </Col>
                        <Col span={colSpan}>
                            <FieldText disable={true} loading={loading} onChanged={fieldOnChanged} title="Цалингийн зэрэглэл" keyfield='salarygrade' defaultValue={data.salarygrade} />
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} style={{ marginTop: 13 }}>
                        <Col span={24}>
                            <FieldTextArea loading={loading} onChanged={fieldOnChanged} title="Нэмэлт мэдээлэл" keyfield='note' defaultValue={data.note} />
                        </Col>
                    </Row>
                </div>
            </div>
        </PanelBase >
    );
}

export default EmpEmplHistNewTR;